export default {
	name: 'PageTitles',
	props: ['mainCar', 'comparedCar'],
	i18n: require('./i18n').default,
};
